import { TableRow as MUITableRow, Tooltip } from '@mui/material';
import moment from 'moment-timezone';

import { REPORT_STATUS_MAP } from '../../../constants';
import {
  getFormattedDateInMomentDefaultTZ,
  getNowInDefaultTimezoneAsDate,
} from '../../../helpers';
import {
  Checkbox,
  IconButton,
  TableBodyCell,
  TableCellDate,
} from '../../Shared';
import { TableCellStatus } from './TableCellStatus';

export const TableRow = ({
  report,
  isRowChecked,
  withBorderBottom,
  isAdmin,
  isManager,
  onSelectRow,
  openActivityLogModal,
  openRescheduleDemoModal,
  onChangeReports,
  filterByStatuses,
}) => {
  const { status, scheduledDate, rescheduledDate } = report;
  const isReportStatusScheduled = status === REPORT_STATUS_MAP.SCHEDULED;
  const isScheduledBookingDatePast =
    isReportStatusScheduled &&
    !rescheduledDate &&
    getFormattedDateInMomentDefaultTZ(getNowInDefaultTimezoneAsDate()).isAfter(
      moment(scheduledDate, 'MM/DD/YYYY, hh:mm A'),
    );
  const isRescheduledBookingDatePast =
    isReportStatusScheduled &&
    !!rescheduledDate &&
    getFormattedDateInMomentDefaultTZ(getNowInDefaultTimezoneAsDate()).isAfter(
      moment(rescheduledDate, 'MM/DD/YYYY, hh:mm A'),
    );

  return (
    <MUITableRow>
      {(isAdmin || isManager) && (
        <>
          <TableBodyCell withBorderBottom={withBorderBottom} width="48px">
            <Checkbox
              color="primary"
              checked={isRowChecked}
              onChange={() => {
                onSelectRow(report.apptID);
              }}
              size="xl"
            />
          </TableBodyCell>
          {isAdmin && (
            <TableBodyCell withBorderBottom={withBorderBottom}>
              {report.tenantName}
            </TableBodyCell>
          )}
          <TableBodyCell withBorderBottom={withBorderBottom}>
            {report.fullName}
          </TableBodyCell>
        </>
      )}
      <TableCellDate
        date={report.createdAt}
        className="font-normal"
        withBorderBottom={withBorderBottom}
      />
      <TableCellDate
        date={scheduledDate}
        withBorderBottom={withBorderBottom}
        isPast={isScheduledBookingDatePast}
      />
      <TableCellDate
        date={report.rescheduledDate}
        withBorderBottom={withBorderBottom}
        isPast={isRescheduledBookingDatePast}
      />
      {!isAdmin && (
        <TableBodyCell withBorderBottom={withBorderBottom}>
          {report.apptType}
        </TableBodyCell>
      )}
      <TableBodyCell withBorderBottom={withBorderBottom}>
        {report.companyName}
      </TableBodyCell>
      <TableBodyCell withBorderBottom={withBorderBottom}>
        {report.contactName}
      </TableBodyCell>
      <TableBodyCell withBorderBottom={withBorderBottom} className="max-w-80">
        {report.contactTitle || '-'}
      </TableBodyCell>
      <TableBodyCell withBorderBottom={withBorderBottom}>
        {report.phoneNumber || '-'}
      </TableBodyCell>
      <TableBodyCell withBorderBottom={withBorderBottom}>
        {report.email || '-'}
      </TableBodyCell>
      <TableCellStatus
        withBorderBottom={withBorderBottom}
        status={status}
        leadID={report.leadID}
        apptID={report.apptID}
        onChangeReports={onChangeReports}
        filterByStatuses={filterByStatuses}
      />
      <TableBodyCell
        align="center"
        withBorderBottom={withBorderBottom}
        width="104px"
      >
        <div className="flex gap-4 w-fit">
          <Tooltip title="Activity Log" placement="top">
            <span>
              <IconButton
                buttonProps={{
                  className: 'w-8 h-8',
                  onClick: () => {
                    openActivityLogModal(report.apptID);
                  },
                }}
                iconProps={{
                  name: 'clock',
                  className: 'h-5',
                }}
              />
            </span>
          </Tooltip>
          <Tooltip title="Reschedule" placement="top">
            <span>
              <IconButton
                buttonProps={{
                  className: 'w-8 h-8',
                  onClick: () => {
                    openRescheduleDemoModal(report.apptID);
                  },
                }}
                iconProps={{
                  name: 'calendar',
                  className: 'h-5',
                }}
              />
            </span>
          </Tooltip>
        </div>
      </TableBodyCell>
    </MUITableRow>
  );
};
